import { useTranslation } from "react-i18next";

const FOOTER_HOME_URL = "https://app.haatsign.sa";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer
      style={{
        fontSize: "0.875rem",
        color: "#6b7280",
        textAlign: "center",
        padding: "1rem 0",
      }}
    >
      {t("footer.poweredBy")}{" "}
      <a
        href={FOOTER_HOME_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "#205c20",
          textDecoration: "none",
          fontWeight: 500,
        }}
        onMouseOver={(event) => {
          event.currentTarget.style.textDecoration = "underline";
        }}
        onMouseOut={(event) => {
          event.currentTarget.style.textDecoration = "none";
        }}
      >
        {t("footer.haatSign")}
      </a>
    </footer>
  );
};

export default Footer;
